import * as React from "react";
import { useParams } from "react-router-dom";

import { Context, verifyMFA } from "../../../teacherStore";
import MultiFactorAuthenticationForm from "../../../templates/teacher/MultiFactorAuthenticationForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const { ott } = useParams<{ ott: string }>();
  const verifyMFAFunc = React.useCallback(
    (mfa_code: string) => {
      dispatch(peep(verifyMFA(ott.trim(), mfa_code)));
    },
    [dispatch, ott, peep],
  );

  return (
    <MultiFactorAuthenticationForm calling={calling} onSubmit={verifyMFAFunc} />
  );
};
